import React from "react";
import { Link } from "react-router-dom";

const DohopHeader: React.FC = () => {
    return (
        <header className="bg-dohop-blue text-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
                {/* Logo */}
                <Link to="/dohop" className="flex items-center space-x-2">
                    <div className="text-2xl font-bold tracking-tight">
                        <span className="text-white">dohop</span>
                    </div>
                </Link>

                {/* Navigation */}
                <nav className="hidden md:flex items-center space-x-8">
                    <Link
                        to="/dohop"
                        className="text-white/90 hover:text-white transition-colors font-medium"
                    >
                        Flights
                    </Link>
                    <a
                        href="#"
                        className="text-white/90 hover:text-white transition-colors font-medium"
                    >
                        Hotels
                    </a>
                    <a
                        href="#"
                        className="text-white/90 hover:text-white transition-colors font-medium"
                    >
                        Car Rental
                    </a>
                </nav>

                {/* Right side */}
                <div className="flex items-center space-x-4">
                    <button className="text-white/90 hover:text-white transition-colors">
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                            />
                        </svg>
                    </button>
                    <button className="bg-white text-dohop-blue px-4 py-2 rounded-lg font-semibold hover:bg-dohop-ice transition-colors">
                        Sign In
                    </button>
                </div>
            </div>
        </header>
    );
};

export default DohopHeader;
